import PropTypes from 'prop-types';
import React from 'react';
import FullPageLayout from '../layouts/fullPageLayout';
import ForestAnimationView from './components/ForestAnimationView';
import withBlockedBackNavigation from '../utils/withBlockedBackNavigation';
import AlyxInterstitialView from './components/AlyxInterstitialView';
import isAlexEnabled from '../alex/AlexUtils';

const InterstitialView = (props) => (
    <div>
        <FullPageLayout>
            {isAlexEnabled() ? (
                <AlyxInterstitialView recentlyCompletedMeasure={props.recentlyCompletedMeasure} onAnimationEnd={props.goToNextPage} />
            ) : (
                <ForestAnimationView
                    onAnimationEnd={props.goToNextPage}
                />
            )}
        </FullPageLayout>
    </div>
);

InterstitialView.propTypes = {
    goToNextPage: PropTypes.func.isRequired,
    recentlyCompletedMeasure: PropTypes.string.isRequired,
};

export default withBlockedBackNavigation(InterstitialView);
